import { inject, injectable } from "inversify";
import Result from "@/core/common/Result";
import "reflect-metadata";
import {
  ICriarAgendamentoUseCase,
  SalvarAgendamentoInput
} from "../ports/CriarAgendamentoUseCase";
import {
  criarAgendamentosGatewayDI,
  type ICriarAgendamentoGateway
} from "../ports/CriarAgendamentoGateway";

@injectable()
export class CriarAgendamentoUseCaseAdapter
  implements ICriarAgendamentoUseCase
{
  constructor(
    @inject(criarAgendamentosGatewayDI)
    private readonly gateway: ICriarAgendamentoGateway
  ) {}

  async execute(input: SalvarAgendamentoInput): Promise<Result<void>> {
    const response = await this.gateway.criarAgendamento(input);

    if (response.isFailure) return Result.fail(response.error);

    return Result.ok();
  }
}
